var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.04237 0.00053763C7.4086 -0.0359476 9.54891 1.78831 9.95319 4.33012C10.1078 5.31522 9.86996 6.23952 9.47757 7.13949C8.8117 8.63538 7.93179 10.0218 6.94487 11.3231C5.98173 12.6001 4.07923 12.6488 3.09231 11.3718C1.9746 9.96101 1.02335 8.42863 0.345584 6.72599C-0.974274 3.45447 1.68922 -0.0359476 4.89969 0.00053763C4.94725 0.00053763 4.99481 0.00053763 5.04237 0.00053763ZM6.99243 5.08415C6.99243 3.92878 6.10064 3.00449 4.99481 3.00449C3.90088 3.00449 2.9853 3.92878 2.9853 5.04766C2.9853 6.21519 3.85331 7.13949 4.95914 7.15165C6.12442 7.15165 6.99243 6.26384 6.99243 5.08415Z",
    fill: "#05D6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMapIcon);
export default __webpack_public_path__ + "static/media/BlueMapIcon.07a3efd73daa7c0ed82797a42d8b8098.svg";
export { ForwardRef as ReactComponent };